import { render, staticRenderFns } from "./LightboxProfileArrow.vue?vue&type=template&id=4b170d86&"
import script from "./LightboxProfileArrow.vue?vue&type=script&lang=js&"
export * from "./LightboxProfileArrow.vue?vue&type=script&lang=js&"
import style0 from "./LightboxProfileArrow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports